// extracted by mini-css-extract-plugin
export default {"button":"style_button__hCTdV","loaderStyle":"style_loaderStyle__lbK5c"};